export function AdminBoundariesToArray(object) {
  if (typeof(object) === 'object') {
    let a = []
    for (const [level, level_values] of Object.entries(object)) {
      if (level == 0) {
        level_values.forEach(value => {a.push({level: level, value: value})})
      } else {
        for (const [country, country_values] of Object.entries(level_values)) {
          country_values.forEach(value => {a.push({level: level, country: country, value: value})})
        }
      }
    }
    return a
  } else {
    return []
  }
}
